import React from "react";
import { Link } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";
import aboutStrings from "../../strings/about";

export default function About() {
  return (
    <div className="footer-nav-col">
      <div className="title">
        <span>{getString("about.title.0")}</span>
      </div>

      <Link to={routeCodes.STORY}>{getString("story.title.1", { strings: aboutStrings }).toLowerCase()}</Link>
      <Link to={routeCodes.TEAM} className="nocap">
        {getString("team.title.1", { strings: aboutStrings })}
      </Link>
      <Link to={routeCodes.TESTIMONIALS}>
        {getString("testimonials.title.0", { strings: aboutStrings }).toLowerCase()}
      </Link>
      <Link to={routeCodes.PRODUCTOFFERINGS}>{getString("productOfferings.title.1", { strings: aboutStrings })}</Link>
      <Link to={routeCodes.TERMS} className="nocap">
        {getString("terms.title.1")}
      </Link>
      <Link to={routeCodes.PRIVACY}>{getString("privacy.title").toLowerCase()}</Link>
      <Link to={routeCodes.PRIVACYMOBILE}>{getString("privacymobile.title").toLowerCase()}</Link>
      <Link to={routeCodes.PAYTERMS}>{getString("payterms.title").toLowerCase()}</Link>
    </div>
  );
}
